@let isEditing =
  clustersEc.plugins.currentEntityPlugin.feature.selectors
    .isEditing()
    .asSignal();

<atn-ds-page [scrollable]="true">
  <div class="atn-cluster-details">
    <atn-ds-page-header
      pageHeader
      [name]="clusterNameSg()"
      [breadcrumbs]="breadcrumbsSg()"
    />

    <div class="atn-cluster-details__content">
      <atn-space-cluster-general />
      <atn-space-cluster-functional-usage />
      <atn-space-occupants
        [collection]="occupantsEc"
        [warningPlugin]="clusterWarningsPlugin"
      />
      <atn-space-responsible-persons
        [collection]="clusterResponsiblePersonsEc"
      />
      <atn-space-cluster-assigned-records />
    </div>
  </div>
</atn-ds-page>

@if (isEditing) {
  <atn-space-cluster-modal />
}
